/**
 * The layer grid a layered texture's **Import sidecar** names, read before the image so a missing
 * sidecar costs no decode. Both layered processors share it.
 */
import { readImportSidecar } from './readImportSidecar';
/** `slicesOf` reads the grid from the parsed sidecar. `noun` names the import in the error. */
export async function readLayeredSlices(read, slicesOf, noun) {
    const slices = slicesOf(await readImportSidecar(read));
    if (!slices)
        throw new Error(`${read.assetPath} has no sidecar that imports it as ${noun}`);
    return slices;
}
//# sourceMappingURL=readLayeredSlices.js.map